export const PAYMENT_METHOD_STRIPE = 'stripe'
export const PAYMENT_METHOD_CASH = 'cash'
export const PAYMENT_METHOD_PAYPAL = 'Paypal'
export const PAYMENT_METHOD_BRAINTREE = 'Braintree'
export const PAYMENT_METHOD_AFTERPAY = 'Afterpay'
export const PAYMENT_METHOD_SPOONDOLLARS = 'spoondollars'
export const PAYMENT_METHOD_PURCHASE_ORDER = 'PurchaseOrder'
export const PAYMENT_METHOD_APPLEPAY = 'ApplePay'
export const PAYMENT_METHOD_GOOGLEPAY = 'GooglePay'
export const STRIPE_KEY = process.env.NEXT_PUBLIC_STRIPE_KEY || ''
export const CHECKOUT_METHOD_APPLEPAY = 'Apple Checkout'
export const CHECKOUT_METHOD_GOOGLEPAY = 'Google Checkout'
export const CHECKOUT_METHOD_PAYPAL = 'PayPal Checkout'
export const CHECKOUT_METHOD_SPOONFLOWER = 'Spoonflower'

export const ADDRESS_FIELD_MAX_LENGTH = 50 // Maximum length for address fields
export const PO_BOX_PREFIX = 'PO BOX '

// Latin/Latin-Extended characters (including punctuation) minus control codes(non printable characters)
export const STANDARD_CHARACTERS_REGEX = /^[\u0020-\u007E\u00A0-\u024F]*$/

export const normalizeSmartQuotes = (value: string) =>
  value.replace(/[\u2018-\u201B]/g, "'").replace(/[\u201C-\u201F]/g, '"')

export const truncateAddressField = (
  value: string | undefined,
  maxLength = ADDRESS_FIELD_MAX_LENGTH
) => normalizeSmartQuotes(value ?? '').slice(0, maxLength)
